module.exports = __webpack_public_path__ + "img/47_38.7501b2b0.png";